export const getInitials = (name) => {
    try {
      if (typeof name !== 'string' || !name.trim()) {
            return '';
      }
      
      const parts = name.trim().split(' '); // Trim spaces and split by space
      
      if (parts.length === 1) {
        // If there's only one part (single word), return the first and last character of that word
        const singleName = parts[0];
        if (singleName.length === 1) {
          return singleName.toUpperCase(); // Single character name
        }
        return (singleName[0] + singleName[singleName.length - 1]).toUpperCase(); // First and last letter
      }
  
      // Otherwise, return the initials from the first and last words
      const firstName = parts[0];
      const lastName = parts[parts.length - 1];
  
      return (firstName[0] + lastName[0]).toUpperCase();
      
    } catch (error) {
      console.error(error.message);
      return ''; // Return an empty string in case of error
    }
  };

  export const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }